/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../mq/services/error.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private baseUrl = environment.baseurl;

  // Variable to store the last error message
  private lastErrorMessage: string = '';

  constructor(private http: HttpClient, private errorService: ErrorService) { }

  // Getter for the last error message
  getLastErrorMessage(): string {
    return this.lastErrorMessage;
  }

  // Error handling logic
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    // Store the error in the service variables
    this.lastErrorMessage = error.error?.error || errorMessage;
    this.errorService.errorMessage = this.lastErrorMessage;

    // Debugging logs

    return throwError(this.lastErrorMessage);
  }

  // GET request
  get<T>(url: string, options?: any): Observable<any> {
    return this.http.get<T>(`${this.baseUrl}/${url}`, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  // POST request
  post<T>(url: string, data: any, options?: any): Observable<any> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, data, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  // PUT request
  put<T>(url: string, data: any, options?: any): Observable<any> {
    return this.http.put<T>(`${this.baseUrl}/${url}`, data, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  // DELETE request
  delete<T>(url: string, options?: any): Observable<any> {
    return this.http.delete<T>(`${this.baseUrl}/${url}`, options)
      .pipe(catchError(this.handleError.bind(this)));
  }
}
